import { PerformanceHistory } from '@products/models/performance-history';
import { ChartConfig, CurrencyCode, FundId, ShareClassCode } from '@types';
import { IndexesAllocation } from '../us-index-allocations/us-index-allocations.config';
import { IndexDetails } from './model/index-details';
import {
  IndexCustomPerformance,
  IndexLevels,
  IndexPerformance,
} from './model/indexes';

export interface USIndexPerformanceState {
  data: USIndexPerformanceData;
  config: IndexesPerformanceTabConfig;
  hasLoadedFullFeed?: boolean;
}

export interface USIndexPerformanceData {
  daily?: IndexPerformance;
  indexLevels?: IndexLevels[];
  custom?: IndexCustomPerformance;
  timeSeries?: PerformanceHistory;
  indexDetails?: IndexDetails;
}
export interface IndexesPerformanceTabConfig {
  asOfDate: string;
  asOfDateStd: string;
  incDateStd: string;
  currencyCode: CurrencyCode;
  chartConfig?: ChartConfig & {
    seriesName: string;
    annualizedReturn?: string;
  };
  tableConfig?: USIndexPerformanceTimeSeriesTableData;
  selectedPerformanceView?: USIndexPerformanceView;
}

export interface USIndexPerformanceTimeSeriesTableData {
  lable: string;
  asOfDate: string;
  header: string[];
  body: string[];
}

export interface IndexesPerformanceBRConfig {
  fundId: FundId;
  fundName: string;
  shareClassCode: ShareClassCode;
  bannerImageURL: string;
  tabs?: [
    {
      id: string;
      label: string;
      tabsPerformance?: [
        {
          id: string;
          label: string;
        }
      ];
    }
  ];
}

export interface USIndexAllocationsBRConfig {
  fundId: FundId;
  fundName: string;
  shareClassCode: ShareClassCode;
  allocationsSeriesOrder?: IndexesAllocation[];
  allocationsLegendOrder?: IndexesAllocation[];
  allocationsYMax?: number;
  allocationsYMin?: number;
  allocationsYTickInterval?: number;
}

export interface USIndexBannerBRConfig {
  fundId: FundId;
  fundName: string;
  shareClassCode?: ShareClassCode;
  bannerImageURL?: string;
  ticker?: string;
  bofaLogoUrl?: string;
}

export interface DownloadAllDataXlsx {
  asOfDateStd?: string;
  indexLevel?: string;
}

export enum USIndexPerformanceView {
  MONTHLY = 'MONTHLY',
  QUARTERLY = 'QUARTERLY',
}

export interface USIndexPerformanceTableBarChartRow {
  y: number;
  decimals: number;
}
